// extracted by mini-css-extract-plugin
export default {"mainContainer":"Login_mainContainer__6NKM3","loginContainer":"Login_loginContainer__vjFUt","buttonContainer":"Login_buttonContainer__lRo8i","loginPanel":"Login_loginPanel__Fv93b"};